// extracted by mini-css-extract-plugin
export default {"content":"ContentDeletePopup_content__nQLZ6","buttons":"ContentDeletePopup_buttons__uPTN2","button":"ContentDeletePopup_button__WsbiE"};